module.exports = __webpack_public_path__ + "img/rata.99f36bcc.webp";